import styled from '@emotion/styled'

export const EnterButtonWrapper = styled.span`
  cursor: pointer;
`
